module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-0970.20459758.jpg";